import { scheduleOnce } from '@ember/runloop';
import Modifier from 'ember-modifier';

// @ts-ignore
import { registerDestructor } from '@ember/destroyable';

interface IArgs {
  positional: [boolean, string];
  named: {};
}

export default class AutofocusModifier extends Modifier<IArgs> {
  elementToFocus: HTMLInputElement | null = null;

  constructor(owner: any, args: IArgs) {
    super(owner, args);

    registerDestructor(this, () => {
      this.elementToFocus?.blur();
    });
  }

  modify(element: Element | null, [active, selector = 'input:not([disabled])']: [boolean, string]) {
    if (!active || !element) {
      return;
    }

    (document.activeElement as HTMLElement | null)?.blur();
    const childElement: HTMLElement | null = element.querySelector(selector);
    this.elementToFocus = (childElement || element) as HTMLInputElement;

    scheduleOnce('afterRender', this, () => this.elementToFocus?.focus());
  }
}
